import React, {
	createContext,
	PropsWithChildren,
	ReactElement,
	useContext,
	useEffect,
	useRef,
	useState,
} from 'react';

import { switchHorizontal } from '@/assets/icons';
import { CopilotHeader } from '@/components/CopilotHeader';
import { PublicCopilotLayout } from '@/components/PublicCopilotLayout';
import { AsaphButton } from '@/components/shared/Button';
import { ItemsList } from '@/components/shared/ItemsList';
import { privacyPolicyLink, termsOfServiceLink } from '@/config/constants';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { useAuth } from '@/providers/AuthProvider';
import { useEnvironment } from '@/providers/EnvironmentProvider';
import { GraphQlTransportWsNextOperation } from '@/providers/TeamActionSubscription';
import { SvgIcon } from '@material-ui/core';
import axios, { AxiosError } from 'axios';
import { format } from 'date-fns';
import {
	OptionsObject,
	SnackbarKey,
	SnackbarMessage,
	useSnackbar,
} from 'notistack';

import { CopilotContext, CopilotState, sendMessageToPco } from '../CopilotPage';
import styles from '../CopilotPage.module.scss';

export type AuthErrorResponse = {
	code: string;
	message: string;
};

const CopilotCreateUser: React.FC = () => {
	const { authData, setToken, setState, token } = useContext(CopilotContext);
	const {
		api: { url },
		environment,
	} = useEnvironment();
	const { handleError } = useErrorHandler();

	useEffect(() => {
		const runAsync = async () => {
			try {
				await axios.post(`${url}/copilot/create-user`, authData);
				// Retry logging in the user
				setState(CopilotState.AuthUser);
			} catch (err) {
				setState(CopilotState.Error);
				handleError({
					error: err,
					errorCode: 'CopilotCreateError',
					friendlyMessage:
						'Something went wrong. Please try again later.',
				});
			}
		};
		if (authData && !token) {
			runAsync();
		}
	}, [authData, handleError, setState, setToken, url, token]);
	return (
		<>
			<h2>Progress</h2>
			<ItemsList
				items={[
					{
						label: 'Creating Asaph account...',
						checked: false,
					},
				]}
			/>
		</>
	);
};

export default CopilotCreateUser;
